const NOTIFICATION_ICON = '/favicon.ico'

export function isBrowserNotificationSupported() {
  return typeof window !== 'undefined' && 'Notification' in window
}

export async function requestBrowserNotificationPermission() {
  if (!isBrowserNotificationSupported()) {
    return 'unsupported'
  }

  if (Notification.permission === 'granted') {
    return 'granted'
  }

  if (Notification.permission === 'denied') {
    return 'denied'
  }

  try {
    return await Notification.requestPermission()
  } catch {
    return 'denied'
  }
}

export function showBrowserNotification(alert) {
  if (!alert?.body || !isBrowserNotificationSupported()) {
    return
  }

  if (Notification.permission !== 'granted') {
    return
  }

  try {
    const notification = new Notification(alert.title || '🔔 Sert4game', {
      body: alert.body,
      icon: NOTIFICATION_ICON,
      tag: alert.tag || 'browser-alert',
      data: { url: alert.url },
    })

    notification.onclick = () => {
      try {
        window.focus()
        if (alert.url) {
          window.open(alert.url, '_blank', 'noopener,noreferrer')
        }
      } finally {
        notification.close()
      }
    }
  } catch (err) {
    console.warn('Browser notification failed:', err)
  }
}

export function showPriceAlertNotification(alert) {
  showBrowserNotification({
    ...alert,
    tag: alert.tag || `price-alert-${alert.gamesserver_id}-${alert.type}-${alert.telegram_price_id}`,
  })
}
